var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.tourOperatorInfo
    ? _c(
        "booking-block",
        {
          staticClass: "booking-block--payment-details",
          attrs: {
            valid: true,
            editMode: false,
            title: _vm.translations.header,
            subTitle: _vm.tourOperatorInfo.name
              ? _vm.tourOperatorInfo.name
              : "",
            showEditBtn: false,
            showSaveBtn: false,
            isCollapsed: _vm.isCollapsed
          }
        },
        [
          _c("template", { slot: "view" }, [
            _c("div", { staticClass: "booking-travel-agency-grid" }, [
              _c("div", { staticClass: "to-block" }, [
                _c("div", { staticClass: "to-block__header" }, [
                  _vm.tourOperatorInfo.name
                    ? _c("h3", {
                        domProps: {
                          textContent: _vm._s(_vm.tourOperatorInfo.name)
                        }
                      })
                    : _vm._e()
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "to-block__content" }, [
                  _vm.tourOperatorInfo.street
                    ? _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.tourOperatorInfo.street)
                        }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tourOperatorInfo.zipCode
                    ? _c("p", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.tourOperatorInfo.zipCode) +
                            ", " +
                            _vm._s(_vm.tourOperatorInfo.city) +
                            "\n          "
                        )
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.tourOperatorInfo.country
                    ? _c("p", {
                        domProps: {
                          textContent: _vm._s(_vm.tourOperatorInfo.country.name)
                        }
                      })
                    : _vm._e()
                ])
              ]),
              _vm._v(" "),
              _vm.tourOperator && _vm.tourOperator.logo
                ? _c("img", {
                    attrs: {
                      src: _vm.tourOperator.logo,
                      alt: _vm.tourOperator.name
                    }
                  })
                : _vm._e()
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c("p", {
              staticClass: "booking-travel-agency-notice",
              domProps: { textContent: _vm._s(_vm.noticeTxt) }
            }),
            _vm._v(" "),
            _c("ul", { staticClass: "booking-travel-agency-list" }, [
              _c("li", [
                _c(
                  "svg",
                  {
                    staticClass: "booking-icon booking-icon--check",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 262.39 260.6"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M248.88,3.42c-13-7-29.61-2.92-37.16,9.08v0L105.62,181.3,49.94,108.64C41.73,97,24.88,93.75,12.31,101.35s-16.09,23.2-7.87,34.83c.38.54.78,1.06,1.2,1.57L91.87,250.39a27.19,27.19,0,0,0,17.47,10.21h.15A26.82,26.82,0,0,0,126,248.92L258.71,37.83C266.24,25.81,261.84,10.42,248.88,3.42Z"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.BookingCheckListPrice)
                  }
                })
              ]),
              _vm._v(" "),
              _c("li", [
                _c(
                  "svg",
                  {
                    staticClass: "booking-icon booking-icon--check",
                    attrs: {
                      xmlns: "http://www.w3.org/2000/svg",
                      viewBox: "0 0 262.39 260.6"
                    }
                  },
                  [
                    _c("path", {
                      attrs: {
                        d:
                          "M248.88,3.42c-13-7-29.61-2.92-37.16,9.08v0L105.62,181.3,49.94,108.64C41.73,97,24.88,93.75,12.31,101.35s-16.09,23.2-7.87,34.83c.38.54.78,1.06,1.2,1.57L91.87,250.39a27.19,27.19,0,0,0,17.47,10.21h.15A26.82,26.82,0,0,0,126,248.92L258.71,37.83C266.24,25.81,261.84,10.42,248.88,3.42Z"
                      }
                    })
                  ]
                ),
                _vm._v(" "),
                _c("span", {
                  domProps: {
                    textContent: _vm._s(_vm.translations.BookingCheckListFees)
                  }
                })
              ])
            ])
          ])
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2792731c", { render: render, staticRenderFns: staticRenderFns })
  }
}